import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=1aa787d8&scoped=true&"
import script from "./RadioButtons.vue?vue&type=script&lang=js&"
export * from "./RadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=1aa787d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa787d8",
  null
  
)

export default component.exports